/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  LibBytesRichErrorsV061,
  LibBytesRichErrorsV061Interface,
} from "../LibBytesRichErrorsV061";

const _abi = [
  {
    inputs: [],
    name: "INVALID_BYTE_OPERATION_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType:
          "enum LibBytesRichErrorsV06_1.InvalidByteOperationErrorCodes",
        name: "errorCode",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "offset",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "required",
        type: "uint256",
      },
    ],
    name: "InvalidByteOperationError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

export class LibBytesRichErrorsV061__factory {
  static readonly abi = _abi;
  static createInterface(): LibBytesRichErrorsV061Interface {
    return new utils.Interface(_abi) as LibBytesRichErrorsV061Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LibBytesRichErrorsV061 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LibBytesRichErrorsV061;
  }
}
